import { isDate, isValid } from '@core/date.facade';

export function isValidDate(date: any): boolean {
    return isDate(date) && isValid(date);
}
